import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import { keyframes } from "@mui/system";

import {
  Box,
  Grid,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  CircularProgress,
} from "@mui/material";

import MDTypography from "components/MDTypography";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

// Icons
import PeopleIcon from "@mui/icons-material/People";
import WarningIcon from "@mui/icons-material/Warning";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import TotalCareCoordinatorPatients from "./TotalCareCoordinatorPatients";
import ScienceIcon from '@mui/icons-material/Science';
import TotalCareCoordinatorDoctors from "./TotalCareCoordinatorDoctors";
import TotalCriticalPatientsPopup from "./TotalCriticalPatients";
import TotalDoctorsWorkingPopup from "./TotalDoctorsWorking";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";


function CareCoordinatorsDashboard() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;

  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [openTotalPatientModal, setOpenTotalPatientModal] = useState(false);
  const [openTotalDoctorModal, setOpenTotalDoctorModal] = useState(false);
  const [openTotalCriticalPatientsModal, setOpenTotalCriticalPatientsModal] = useState(false);
  const [openTotalDoctorsWorkingModal, setOpenTotalDoctorsWorkingModal] = useState(false);

  const fetchdata = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/dashboard/carecoordinator/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
       console.log("display test",decryptedData);
        setStats(decryptedData || null);
      }
    } catch (error) {
      // toast.error("Failed to fetch dashboard data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  const patientCards = [
    {
      label: "Total Patients",
      key: "totalPatientsToCall",
      icon: <PeopleIcon sx={{ fontSize: 55, color: "#2e7fae" }} />,
      bg: "#e3f2fd",
      modalType: "TOTAL_PATIENTS",
    },
    {
      label: "Critical Patients",
      key: "totalCriticalPatients",
      icon: <WarningIcon sx={{ fontSize: 55, color: "#d32f2f" }} />,
      bg: "#ffebee",
      modalType: "CRITICAL_PATIENTS",
    },
   
  ];

  const handleOpenTotalPatient = async (id) => {
          setOpenTotalPatientModal(true); 
    };
   const handleCloseTotalPatientModal = () => {
      setOpenTotalPatientModal(false);
    };

     const handleCloseTotalDoctorModal = () => {
      setOpenTotalDoctorModal(false);
    };

    const handleCloseTotalDoctorWorkingModal = () => {
      setOpenTotalDoctorsWorkingModal(false);
    };

    const handleCloseTotalCriticalPatientModal = () => {
      setOpenTotalCriticalPatientsModal(false);
    };

    const DoctorIcon = ({ size = 55, color = "#2e7d32", sx = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={sx}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2Z"/>
    <path d="M6 20V19C6 15.6863 8.68629 13 12 13C15.3137 13 18 15.6863 18 19V20H20V19C20 14.5817 16.4183 11 12 11C7.58172 11 4 14.5817 4 19V20H6Z"/>
    <path d="M18 7H20V12C20 13.6569 18.6569 15 17 15C15.3431 15 14 13.6569 14 12V11H16V12C16 12.5523 16.4477 13 17 13C17.5523 13 18 12.5523 18 12V7Z"/>
  </svg>
);



  const doctorCards = [
    {
      label: "Total Doctors",
      key: "totalDoctorsAssociated",
      icon: <DoctorIcon size={23} color="green" />,
      bg: "#e8f5e9",
      modalType: "TOTAL_DOCTORS", 
    },
    {
      label: "Doctors Working",
      key: "totalDoctorsWorking",
      icon: <MedicalServicesIcon sx={{ fontSize: 55, color: "#6a1b9a" }} />,
      bg: "#f3e5f5",
      modalType: "TOTAL_DOCTORS_WORKING",
    },
  ];
 const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />
<MedicalAbstractBackground/>
      {loading ? (
       <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      ) : (
        <Box sx={{ p: 3 }}>

          {/* <MDTypography variant="h4" fontWeight="bold" mb={2}>
            Care Coordinator Dashboard
          </MDTypography> */}

          <MDTypography variant="h5" fontWeight="bold" mb={1} mt={2}>
            Patient Summary
          </MDTypography>

          <Grid container spacing={3}>
            {patientCards.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                 
                  sx={{
                    borderRadius: "18px",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                    backgroundColor: item.bg,
                    height: 155,
                   
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3,
                    cursor: "pointer",
                  "&:nth-of-type(even)": {  },
                  "&:hover": {  }, 
                }}
                
                 onClick={(e) => {
    e.stopPropagation();

    if (item.modalType === "TOTAL_PATIENTS") {
      setOpenTotalPatientModal(true);
    }

    if (item.modalType === "CRITICAL_PATIENTS") {
      setOpenTotalCriticalPatientsModal(true);
    }

   
  }}
                 >
                      {item.icon}
                      <Box>
                        <MDTypography variant="h6" fontWeight="bold">
                          {item.label}
                        </MDTypography>
                        <MDTypography variant="h3" fontWeight="bold">
                          {stats?.[item.key] ?? 0}
                        </MDTypography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

         

          <MDTypography variant="h5" fontWeight="bold" mb={1} mt={5}>
            Doctor Summary
          </MDTypography>

          <Grid container spacing={3}>
            {doctorCards.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    borderRadius: "18px",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                    backgroundColor: item.bg,
                    height: 155,
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3, 
                      cursor: "pointer",
                  "&:nth-of-type(even)": {  },
                  "&:hover": {  }, 
                
                    }}
                    
                     onClick={(e) => {
    e.stopPropagation();

    if (item.modalType === "TOTAL_DOCTORS") {
      setOpenTotalDoctorModal(true);
    }

     if (item.modalType === "TOTAL_DOCTORS_WORKING") {
      setOpenTotalDoctorsWorkingModal(true);
    }

   

    
  }}
                    >
                      
                      {item.icon}
                      <Box>
                        <MDTypography variant="h6" fontWeight="bold">
                          {item.label}
                        </MDTypography>
                        <MDTypography variant="h3" fontWeight="bold">
                          {stats?.[item.key] ?? 0}
                        </MDTypography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          {openTotalPatientModal && (
            <TotalCareCoordinatorPatients
              isOpen={openTotalPatientModal}
              onRequestClose={handleCloseTotalPatientModal}
             
            />
          )}

          {openTotalCriticalPatientsModal && (
            <TotalCriticalPatientsPopup
              isOpen={openTotalCriticalPatientsModal}
              onRequestClose={handleCloseTotalCriticalPatientModal}
             
            />
          )}

           {openTotalDoctorModal && (
            <TotalCareCoordinatorDoctors
              isOpen={openTotalDoctorModal}
              onRequestClose={handleCloseTotalDoctorModal}
             
            />
          )}
         
         {openTotalDoctorsWorkingModal && (
            <TotalDoctorsWorkingPopup
              isOpen={openTotalDoctorsWorkingModal}
              onRequestClose={handleCloseTotalDoctorWorkingModal}
             
            />
          )}
         
        </Box>

        
      )}
    </DashboardLayout>
  );
}

export default CareCoordinatorsDashboard;
